/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../application";
import { SOLD_ASSETS } from "../pages/SoldAssets/graphql/sold-assets.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { TEST_DATA} from "./config/assets-test-data"
import {useAsset} from "../pages/SoldAssets/provider"
import {SOUND ,VIDEO } from "../assets"

const MODULE_NAME = "SoldAssetsService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
interface IProps{
    imageServer:any
}

export class SoldAssetsService {
    private static instance: SoldAssetsService;
    private vapp: VApplication;
    private imageServer;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.imageServer = props?.imageServer
    }
    public static getInstance(props: any = {}): SoldAssetsService {
        if (!SoldAssetsService.instance) {
            SoldAssetsService.instance = new SoldAssetsService(props);
        }
        return SoldAssetsService.instance;
    }





    // async getAssets(size: number, offset: number) {
    //     let _found = TEST_DATA;
    //    _found = _found.slice(offset, offset + size);
    //    return {
    //        pagination: {
    //            nextOffset: offset + _found.length,
    //            totalItems: TEST_DATA?.length,  
    //        },
    //        results: _found,
    //    }
    // }
    async getAssets(size: number, offset: number) {
        const getassetsService = SoldAssetsService.getInstance();
        const{ id}= useAsset();

        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: SOLD_ASSETS,
                    variables: {
                        size: size,
                        offset: offset,
                        filter: {
                            state:["sold"],
                            store:id
                          }
                    },
                    fetchPolicy:'network-only'
                });
                log.success(MODULE_NAME, "get assets result: ", res);
                // return res?.data?.getAssets;
              if(res){
                    let _data= res?.data?.getAssets?.data;
                                      
                    let results = _data?.map((item:any)=>{
                        
                        const imgUrl = item?.img;
                        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
                        const imgBBformat = imgUrl?.split('/');
                        const ibbFormat = imgBBformat[imgBBformat.length-3]
                     
                        let _img;
                         if(ibbFormat === "i.ibb.co"){
                            _img = item?.img
                            // _img =`${getassetsService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                         
                         } 
                         else {
                            _img = item?.img
                            //  _img = `${getassetsService.imageServer}${urlFormat}/:/rs=h:500`
                         }
                          console.log("mui",_img)
                          
                         if(item?.type === "audio"){
                            _img = SOUND
                        }
                        if(item?.type === "video"){
                            _img = VIDEO
                        }
                    

                        return({
                            ...item,
                            img:_img,
                            storeId:id,
                            tag: null,
                            networkType:null,
                            // category: item?.tag?.toLowerCase(),
                            tokenId:item?.serialNo,
                            serialNo:`Rare #/${item?.serialNo}`,
                            subtitle:item?.subtitle.replace(/<[^>]*>?/gm, ''),
                            audioDetail: item?.type === "audio" ? true : false,
                            videoDetail: item?.type === "video" ? true : false,
                            price: item?.price?.map(item=>{
                                if(item?.type==='fiat'){
                                    return({
                                        ...item,
                                        locale: 'en-US',
                                    })
                                }
                                else{
                                    return({
                                        ...item,
                                        amount:(item?.amount)?.toFixed(3)
                                    })
                                }
                            }),
                        })
                    })

                    return{
                        pagination: {
                            nextOffset: offset + res?.data?.getAssets?.pageSize,
                            totalItems: res?.data?.getAssets?.totalCount
                        },  
                        results
                    }
                }
            }
        } catch (err) {
            log.error(MODULE_NAME, "error in get assets", err);
            // throw Error(`${err?.message}`)
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }
}
